(function () {
  "use strict";

  var SELECTORS = {
    drawer: "[data-ferrer-cart-drawer]",
    body: "[data-ferrer-cart-body]",
    foot: "[data-ferrer-cart-foot]",
    subtotal: "[data-ferrer-cart-subtotal]",
    progress: "[data-ferrer-cart-progress]",
    progressText: "[data-ferrer-cart-progress-text]",
    progressFill: "[data-ferrer-cart-progress-fill]",
    count: "[data-ferrer-cart-count]"
  };

  var strings = window.ferrerCartStrings || {};
  var threshold = window.ferrerFreeShippingThreshold || 0;

  /* ---------- Money ---------- */
  function formatMoney(cents, format) {
    var f = format || window.ferrerMoneyFormat || "$ {{amount}}";
    if (typeof cents === "string") cents = cents.replace(".", "");
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;

    function withDelimiters(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands || ",";
      decimal = decimal || ".";
      if (isNaN(number) || number == null) return "0";
      number = (number / 100.0).toFixed(precision);
      var parts = number.split(".");
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands);
      var cts = parts[1] ? decimal + parts[1] : "";
      return dollars + cts;
    }

    var match = f.match(placeholder);
    var key = match ? match[1] : "amount";
    var value;
    switch (key) {
      case "amount_no_decimals":
        value = withDelimiters(cents, 0);
        break;
      case "amount_with_comma_separator":
        value = withDelimiters(cents, 2, ".", ",");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = withDelimiters(cents, 0, ".", ",");
        break;
      case "amount_with_space_separator":
        value = withDelimiters(cents, 2, " ", ",");
        break;
      case "amount_no_decimals_with_space_separator":
        value = withDelimiters(cents, 0, " ", "");
        break;
      default:
        value = withDelimiters(cents, 2);
    }
    return f.replace(placeholder, value);
  }

  /* ---------- Drawer ---------- */
  function drawer() {
    return document.querySelector(SELECTORS.drawer);
  }

  function openDrawer() {
    var d = drawer();
    if (!d) return;
    d.classList.add("is-open");
    d.setAttribute("aria-hidden", "false");
    document.body.classList.add("nav-open");
  }

  function closeDrawer() {
    var d = drawer();
    if (!d) return;
    d.classList.remove("is-open");
    d.setAttribute("aria-hidden", "true");
    document.body.classList.remove("nav-open");
  }

  /* ---------- Toast ---------- */
  function toast(message) {
    var el = document.createElement("div");
    el.className = "ferrer-toast";
    el.textContent = message;
    document.body.appendChild(el);
    requestAnimationFrame(function () {
      el.classList.add("is-visible");
    });
    setTimeout(function () {
      el.classList.remove("is-visible");
      setTimeout(function () {
        el.remove();
      }, 300);
    }, 2600);
  }

  /* ---------- Render ---------- */
  function updateCounts(count) {
    document.querySelectorAll(SELECTORS.count).forEach(function (node) {
      node.textContent = count;
      node.hidden = count < 1;
    });
  }

  function renderProgress(totalPrice) {
    var d = drawer();
    if (!d) return;
    var wrap = d.querySelector(SELECTORS.progress);
    if (!wrap || threshold <= 0) {
      if (wrap) wrap.hidden = true;
      return;
    }
    wrap.hidden = false;
    var textEl = d.querySelector(SELECTORS.progressText);
    var fillEl = d.querySelector(SELECTORS.progressFill);
    var pct = Math.min(100, Math.round((totalPrice / threshold) * 100));
    if (fillEl) fillEl.style.width = pct + "%";
    if (textEl) {
      if (totalPrice >= threshold) {
        textEl.textContent = strings.freeShippingHave || "";
        wrap.classList.add("is-complete");
      } else {
        var remaining = formatMoney(threshold - totalPrice);
        textEl.textContent = (strings.freeShippingLeft || "{{ amount }}").replace("{{ amount }}", remaining);
        wrap.classList.remove("is-complete");
      }
    }
  }

  function lineHtml(item, index) {
    var img = item.image
      ? '<img src="' + item.image.replace(/(\.[^.]+)(\?.*)?$/, "_160x$1") + '" alt="" loading="lazy">'
      : "";
    var variant = item.variant_title && item.variant_title !== "Default Title"
      ? '<p class="drawer-line__variant">' + item.variant_title + "</p>"
      : "";
    var onSale = item.original_line_price > item.final_line_price;
    var price =
      '<span class="drawer-line__price">' +
      (onSale ? '<s>' + formatMoney(item.original_line_price) + "</s> " : "") +
      formatMoney(item.final_line_price) +
      "</span>";

    return (
      '<article class="drawer-line" data-line="' + index + '">' +
      '<a href="' + item.url + '" class="drawer-line__media">' + img + "</a>" +
      '<div class="drawer-line__info">' +
      '<a href="' + item.url + '" class="drawer-line__title">' + item.product_title + "</a>" +
      variant +
      '<div class="drawer-line__bottom">' +
      '<div class="drawer-line__qty">' +
      '<button type="button" data-qty-decrease aria-label="-">&minus;</button>' +
      '<span data-qty-value>' + item.quantity + "</span>" +
      '<button type="button" data-qty-increase aria-label="+">+</button>' +
      "</div>" +
      price +
      "</div>" +
      '<button type="button" class="drawer-line__remove" data-remove>' + (strings.remove || "Remove") + "</button>" +
      "</div>" +
      "</article>"
    );
  }

  function renderCart(cart) {
    updateCounts(cart.item_count);

    var d = drawer();
    if (!d) return;
    var body = d.querySelector(SELECTORS.body);
    var foot = d.querySelector(SELECTORS.foot);
    var subtotal = d.querySelector(SELECTORS.subtotal);

    if (!cart.items || cart.items.length === 0) {
      body.innerHTML = '<p class="cart-drawer__empty">' + (strings.empty || "") + "</p>";
      if (foot) foot.hidden = true;
      if (subtotal) subtotal.textContent = "";
      var prog = d.querySelector(SELECTORS.progress);
      if (prog) prog.hidden = true;
      return;
    }

    body.innerHTML = cart.items
      .map(function (item, i) {
        return lineHtml(item, i + 1);
      })
      .join("");

    if (subtotal) subtotal.textContent = formatMoney(cart.total_price);
    if (foot) foot.hidden = false;
    renderProgress(cart.total_price);
  }

  /* ---------- Fetch helpers ---------- */
  function getCart() {
    return fetch("/cart.js", { headers: { Accept: "application/json" } }).then(function (r) {
      return r.json();
    });
  }

  function refresh() {
    return getCart().then(renderCart);
  }

  function addToCart(id, quantity) {
    return fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: id, quantity: quantity || 1 })
    }).then(function (r) {
      if (!r.ok) {
        return r.json().then(function (err) {
          throw new Error(err.description || err.message || "Error");
        });
      }
      return r.json();
    });
  }

  function changeLine(line, quantity) {
    return fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ line: line, quantity: quantity })
    }).then(function (r) {
      return r.json();
    });
  }

  /* ---------- Actions ---------- */
  function handleAdd(id, quantity) {
    return addToCart(id, quantity)
      .then(function () {
        return refresh();
      })
      .then(function () {
        openDrawer();
      })
      .catch(function (e) {
        toast(e.message);
      });
  }

  /* ---------- Bindings ---------- */
  function bind() {
    if (document.body.dataset.ferrerCartBound === "true") return;
    document.body.dataset.ferrerCartBound = "true";

    document.addEventListener("click", function (event) {
      var toggle = event.target.closest("[data-ferrer-cart-toggle]");
      if (toggle) {
        event.preventDefault();
        openDrawer();
        refresh();
        return;
      }

      if (event.target.closest("[data-ferrer-cart-close]")) {
        closeDrawer();
        return;
      }

      var addNow = event.target.closest("[data-ferrer-add-now]");
      if (addNow) {
        event.preventDefault();
        handleAdd(addNow.getAttribute("data-variant-id"), 1);
        return;
      }

      var qaToggle = event.target.closest("[data-ferrer-quick-add-toggle]");
      if (qaToggle) {
        event.preventDefault();
        var wrap = qaToggle.closest("[data-ferrer-quick-add]");
        var panel = wrap && wrap.querySelector("[data-ferrer-quick-add-panel]");
        if (panel) {
          var willOpen = panel.hidden;
          panel.hidden = !willOpen;
          qaToggle.setAttribute("aria-expanded", willOpen ? "true" : "false");
        }
        return;
      }

      var addVariant = event.target.closest("[data-ferrer-add-variant]");
      if (addVariant && !addVariant.disabled) {
        event.preventDefault();
        handleAdd(addVariant.getAttribute("data-ferrer-add-variant"), 1);
        return;
      }

      var dec = event.target.closest("[data-qty-decrease]");
      var inc = event.target.closest("[data-qty-increase]");
      var rem = event.target.closest("[data-remove]");
      if (dec || inc || rem) {
        event.preventDefault();
        var lineEl = event.target.closest("[data-line]");
        if (!lineEl) return;
        var line = parseInt(lineEl.getAttribute("data-line"), 10);
        var current = parseInt(lineEl.querySelector("[data-qty-value]").textContent, 10) || 1;
        var next = current;
        if (rem) next = 0;
        else if (dec) next = Math.max(1, current - 1);
        else if (inc) next = current + 1;
        changeLine(line, next).then(refresh).catch(function () { refresh(); });
      }
    });

    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape") closeDrawer();
    });

    /* PDP add-to-cart form → AJAX + drawer */
    document.addEventListener("submit", function (event) {
      var form = event.target;
      if (!form || !form.getAttribute) return;
      var action = form.getAttribute("action") || "";
      if (action.indexOf("/cart/add") === -1) return;
      event.preventDefault();
      var data = new FormData(form);
      var id = data.get("id");
      var qty = parseInt(data.get("quantity"), 10) || 1;
      handleAdd(id, qty);
    });

    /* Swatch hover → swap card image */
    document.addEventListener("mouseover", function (event) {
      var sw = event.target.closest("[data-ferrer-swatch]");
      if (!sw) return;
      var url = sw.getAttribute("data-image-url");
      if (!url) return;
      var card = sw.closest("[data-ferrer-card]");
      var img = card && card.querySelector(".product-card__image");
      if (img) {
        if (!img.dataset.originalSrc) img.dataset.originalSrc = img.currentSrc || img.src;
        img.src = url;
        img.srcset = "";
      }
    });
    document.addEventListener("mouseout", function (event) {
      var sw = event.target.closest("[data-ferrer-swatch]");
      if (!sw) return;
      var card = sw.closest("[data-ferrer-card]");
      var img = card && card.querySelector(".product-card__image");
      if (img && img.dataset.originalSrc) img.src = img.dataset.originalSrc;
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    bind();
    refresh();
  });
})();
